import { createSelector } from 'reselect'
import { getFormValues } from 'redux-form'
const getPassengerCounts = (state) => state.landingPage.passengers
// const getCustomerInfoFormValues = (state) => ({...state.customerInfoPage})
const getCustomerInfoFormValues = (state) => (getFormValues("customerInfo")(state));
// const getCustomerInfoFormValues = (state) => (state.form.customerInfo.values)

function appendTravellerInfo (passengerType, passengerCount, travellerFormInfoArr) {
  if (passengerCount) {
    for (var i = 1; i <= passengerCount; i++) {
      var id = passengerType + ' ' + i
      travellerFormInfoArr.push({
        id: id,
        firstName: 'firstName_' + id,
        lastName: 'lastName_' + id,
        gender: 'gender_' + id,
        dob: 'dob_' + id
      })
    }
  }
}

export const getTravellerFormInfoArr = createSelector(
  [ getPassengerCounts ],
  (passengerCounts) => {
    var {
      adultCount,
      childCount,
      infantInLapCount,
      infantInSeatCount,
      seniorCount
    } = passengerCounts
    var travellerFormInfoArr = []

    appendTravellerInfo('Adult', adultCount, travellerFormInfoArr)
    appendTravellerInfo('Child', childCount, travellerFormInfoArr)
    appendTravellerInfo('Infant In Lap', infantInLapCount, travellerFormInfoArr)
    appendTravellerInfo('Infant In Seat', infantInSeatCount, travellerFormInfoArr)
    appendTravellerInfo('Senior', seniorCount, travellerFormInfoArr)

    return travellerFormInfoArr
  }
)

/**
 * getTravellerFormValues - Gets array of TravellerForm names. E.g.
 * [dob_Adult 1, firstName_Adult 1, lastName_Adult 1]. The results are
 * used within the redux-form validation function for validating TravellerForm fields
 * @type {[Function]}
 */
export const getTravellerFormValues = createSelector(
  [ getTravellerFormInfoArr ],
  (travellerFormInfoArr) => {
    var travellerFormValues = []
    travellerFormInfoArr.forEach((formInfo) => {
      // travellerFormValues.push(formInfo.id)
      travellerFormValues.push(formInfo.firstName)
      travellerFormValues.push(formInfo.lastName)
      travellerFormValues.push(formInfo.dob)
      travellerFormValues.push(formInfo.gender)
    })

    return travellerFormValues
  }
)

const getTravellers = createSelector(
  [ getTravellerFormInfoArr, getCustomerInfoFormValues ],
  (travellerFormInfoArr, customerInfoFormValues) => {
    var travellers = []

    if (customerInfoFormValues) {
      travellers = travellerFormInfoArr.map((travellerFormInfo) => {
  
        // key --> firstName
        // travellerFormInfo --> {id: "Adult 1", firstName: "firstName_Adult 1", lastName: "lastName_Adult 1"...}
  
        var person = {id: travellerFormInfo.id}
        for (const key in travellerFormInfo) {
          if (key !== 'id' && travellerFormInfo.hasOwnProperty(key)) { // prevent override of id from assignment above
            person[key] = customerInfoFormValues[travellerFormInfo[key]]
          }
        }
        return person
      })

    }
    return travellers
  }
)

const getContactInfo = createSelector(
  [ getCustomerInfoFormValues ],
  (customerInfoFormValues) => {
    if (customerInfoFormValues) {
      return {
        phone: customerInfoFormValues['phone'],
        email: customerInfoFormValues['email']
      }
    }
  }
)

export const getCustomerInfo = createSelector(
  [ getTravellers, getContactInfo ],
  (travellers, contactInfo) => {
    return {
      travellers: travellers,
      contactInfo: contactInfo
    }
  }
)



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/selectors.js